import { PolicyStatus } from '../../types/policies';
import { ShieldCheck, ShieldOff } from 'lucide-react';
import { Badge } from '../../../../ui/common-ui/badge';

interface StatusFilterProps {
  selectedStatus: PolicyStatus | null;
  onStatusChange: (status: PolicyStatus | null) => void;
  counts: { active: number; inactive: number };
}

const statuses: { value: PolicyStatus; label: string; icon: any; color: string }[] = [
  { value: 'ACTIVE', label: 'Active', icon: ShieldCheck, color: 'text-emerald-500' },
  { value: 'INACTIVE', label: 'Inactive', icon: ShieldOff, color: 'text-rose-500' },
];

export const StatusFilter = ({ selectedStatus, onStatusChange, counts }: StatusFilterProps) => {
  return (
    <div className="flex items-center gap-1 p-1 bg-muted/30 rounded-xl">
      {statuses.map(({ value, label, icon: Icon, color }) => (
        <button
          key={value}
          onClick={() => onStatusChange(selectedStatus === value ? null : value)}
          className={`
            flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-300
            ${selectedStatus === value 
              ? `bg-background shadow-sm ${color}` 
              : 'text-muted-foreground hover:text-foreground hover:bg-background/50'
            }
          `}
        >
          <Icon className={`h-4 w-4 transition-all duration-300 ${color} ${selectedStatus === value ? '' : 'opacity-40'}`} />
          {label}
          {counts[value.toLowerCase() as 'active' | 'inactive'] > 0 && (
            <Badge variant="secondary" className="h-4 px-1.5 text-[10px] ml-1 bg-primary/10 text-primary hover:bg-primary/20 border-0 tabular-nums">
              {counts[value.toLowerCase() as 'active' | 'inactive']}
            </Badge>
          )}
        </button>
      ))}
    </div>
  );
};
